import { render } from "./inventariolavanderia.vue?vue&type=template&id=671eacb8&scoped=true"
import script from "./inventariolavanderia.vue?vue&type=script&lang=js"
export * from "./inventariolavanderia.vue?vue&type=script&lang=js"

import "./inventariolavanderia.vue?vue&type=style&index=0&id=671eacb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671eacb8"]])

export default __exports__